import Rellax from 'rellax';

let rellax;

function initParallaxElements() {
    if ($('.rellax').length) {
        rellax = new Rellax('.rellax', {
            speed: -2,
            center: true,
            wrapper: null,
            round: true,
            vertical: true,
            horizontal: false
        });
    }
}

function refreshParallaxElements() {
    if ($('.rellax').length && rellax != null) {
        rellax.refresh();
    }
}

export {refreshParallaxElements as refreshRellax, initParallaxElements as initRellax};